import { GetCookie, IsAdult, ParseJwt } from "api/jwt";
import { GetMember } from "api/secureApi.ts";
import { useState } from "react";

const useGetMember = () => {
  const [memberDetails, setMemberDetails] = useState();
  const [isAdult, setIsAdult] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isMember, setIsMember] = useState();

  const idToken = GetCookie("idToken");
  const membershipNumber = ParseJwt(idToken)["cognito:username"];

  const getMember = async () => {
    setIsLoading(true);
    await GetMember(idToken, membershipNumber).then((response) => {
      setMemberDetails(response);
      setIsAdult(IsAdult(response.dateOfBirth));
      setIsMember(calculateIsMember(response.membershipStatus));
      setIsLoading(false);
    });
    setIsLoading(false);
  };

  const calculateIsMember = (membershipStatus) => {
    return membershipStatus !== "NEW";
  };

  return { getMember, memberDetails, isAdult, isMember, isLoading };
};

export default useGetMember;
